<div class="calendar grid-x" [ngClass]="{ 'calendar-list': currentView == 'listWeek' }">
  @if (!organizationId?.length) {
    <div class="assignment flex">
      <h4 class="h5 bold">Filter Calendars:</h4>
      <div class="checkbox flex">
        <input class="show-for-sr" id="workorders" type="checkbox" [(ngModel)]="showMyWorkOrders" (ngModelChange)="filterEvents()"/>
        <label for="workorders" class="my-work-orders">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          <span class="control-label-text">My Work Orders</span>
        </label>
      </div>
      <div class="section grid-y">
        <div>Group Calendars</div>
        <ul>
          @for (group of groups; track group) {
            <li class="checkbox flex">
              <input class="show-for-sr" [id]="'group-' + group.id" type="checkbox" [(ngModel)]="group.selected" (ngModelChange)="filterEvents()"/>
              <label [for]="'group-' + group.id" class="group-work-orders">
                <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
                <span class="control-label-text">{{group.displayName}}</span>
              </label>
            </li>
          }
        </ul>
      </div>
    </div>
  }

  <div class="content flex grid-y">
    <button class="text-align-right toggle-link link" (click)="toggleView()">
      @if (currentView === calendarTypes.Month) {
        <span>List view</span>
      }
      @if (currentView === calendarTypes.ListMonth) {
        <span>Month view</span>
      }
    </button>

    <text-loader [run]="isLoading" text="Loading" [cycleLimit]="3"></text-loader>
    @if (!isLoading) {
      <full-calendar #calendar [options]="calendarOptions" [events]="filteredEvents" (eventRender)="eventRender($event)"></full-calendar>
    }

    <div class="text-align-right margin-top full-width">
      <a (click)="viewFullCalendar()" aria-label="Show Full Calendar" class="full-calendar-link">Full Calendar <img style="height: 14px; width: 14px;" src="../../../../../assets/images/SVG/angle-double-right-solid.svg" /></a>

    </div>
  </div>
</div>
